import { Box, Typography } from "@mui/material";
import useTranslationSetup from "../../utils/useTranslationSetup";
import "./styles.css";

const CustomActionIcon = ({ children, label }) => {
  const { activeLanguage } = useTranslationSetup();

  return (
    <Box>
      <Box>{children}</Box>
      <Box>
        <Typography marginTop="0" fontSize="14px" lang={activeLanguage} fontFamily="poppins-regular">
          {label}
        </Typography>
      </Box>
    </Box>
  );
};

export default CustomActionIcon;
